import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const tableStyleObj = {
  "/all-crews-management": "all-crew-table",
};

const AllCrewsTable = (props) => {
  const { crewData } = props;
  const location = useLocation();
  const tableHeadings = [
    "Crew Id",
    "Foreman",
    "Gen Foreman ",
    "Ops Manager",
    "Status",
    "Actions",
  ];
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [showActive, setShowActive] = useState(true); // State to toggle between active and inactive crews

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleToggle = (isActive) => {
    setShowActive(isActive);
  };

  const filteredCrewList = crewData
    ?.filter((item) => {
      const nameMatches = item?.name
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      const virtualIdMatches = item?.virtual_id.includes(searchQuery);
      const isActive = item?.is_active;

      return (
        (nameMatches || virtualIdMatches) && (showActive ? isActive : !isActive)
      );
    })
    .sort((a, b) => a.created_at - b.created_at);

  const onClickCrewManagement = (item) => {
    navigate(`/crew-management/${item?.id}`, {
      state: { project_id: item?.project_id, crew_id: item?.id },
    });
  };

  const addTableClass = tableStyleObj[location.pathname] || "";

  return (
    <div className={`table-responsive crew-table ${addTableClass}`}>
      <div className="d-flex align-items-center">
      <div className="search-bar">
        <input
          className="user-search-bar"
          type="text"
          placeholder="Search"
          value={searchQuery}
          onChange={handleSearchChange}
        />
      </div>
      <div className="toggle-buttons">
        <button
          className={`toggle-btn ${showActive ? "active" : ""}`}
          onClick={() => handleToggle(true)}
        >
          Active
        </button>
        <button
          className={`toggle-btn ${!showActive ? "active" : ""}`}
          onClick={() => handleToggle(false)}
        >
          Inactive
        </button>
      </div>
      </div>

      <table className="table table-striped tableV2 table-crew">
        <thead>
          <tr>
            <th style={{width: "10%"}}>Crew Id</th>
            <th>Foreman</th>
            <th>Gen Foreman </th>
            <th>Ops Manager</th>
            <th>Status</th>
            <th style={{width: "10%", textAlign: "center"}}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredCrewList && filteredCrewList.length > 0 ? (
            filteredCrewList.map((item, key) => (
              <tr key={key}>
                <td className="crew-id" ><div>{item?.virtual_id}</div></td>
                <td>{item?._foreman || "-"}</td>
                <td>{item?._general_foreman ?? "-"}</td>
                <td>{item?._ops_manager ?? "-"}</td>
                <td>{item?.is_active ? "Active" : "Inactive"}</td>
                <td className="details-td" style={{textAlign: "center"}}>
                  <svg onClick={() => onClickCrewManagement(item)}  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M505 122.9L517.1 135C526.5 144.4 526.5 159.6 517.1 168.9L488 198.1L441.9 152L471 122.9C480.4 113.5 495.6 113.5 504.9 122.9zM273.8 320.2L408 185.9L454.1 232L319.8 366.2C316.9 369.1 313.3 371.2 309.4 372.3L250.9 389L267.6 330.5C268.7 326.6 270.8 323 273.7 320.1zM437.1 89L239.8 286.2C231.1 294.9 224.8 305.6 221.5 317.3L192.9 417.3C190.5 425.7 192.8 434.7 199 440.9C205.2 447.1 214.2 449.4 222.6 447L322.6 418.4C334.4 415 345.1 408.7 353.7 400.1L551 202.9C579.1 174.8 579.1 129.2 551 101.1L538.9 89C510.8 60.9 465.2 60.9 437.1 89zM152 128C103.4 128 64 167.4 64 216L64 488C64 536.6 103.4 576 152 576L424 576C472.6 576 512 536.6 512 488L512 376C512 362.7 501.3 352 488 352C474.7 352 464 362.7 464 376L464 488C464 510.1 446.1 528 424 528L152 528C129.9 528 112 510.1 112 488L112 216C112 193.9 129.9 176 152 176L264 176C277.3 176 288 165.3 288 152C288 138.7 277.3 128 264 128L152 128z"/></svg>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={tableHeadings.length}>No data</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AllCrewsTable;
